module.exports = __webpack_public_path__ + "img/icon_2_26.73599b0d.png";